var _rect, _rect2, _tspan, _tspan2, _rect3, _rect4, _rect5, _rect6, _rect7, _tspan3, _tspan4, _tspan5, _tspan6, _g, _g2, _path, _g3, _g4, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _ellipse2, _ellipse3, _path8, _path9, _ellipse4, _path0, _path1, _tspan7, _tspan8, _tspan9, _tspan0, _tspan1, _tspan10, _circle, _tspan11, _tspan12, _tspan13, _tspan14, _circle2, _circle3, _path10, _path11, _circle4, _path12, _circle5, _path13, _path14, _path15, _path16, _tspan15, _tspan16, _tspan17, _tspan18, _tspan19, _tspan20, _tspan21, _ellipse5, _path17, _ellipse6, _path18, _ellipse7, _path19, _path20, _path21, _path22, _rect8, _path23, _line, _path24, _path25, _path26, _path27, _path28, _g5, _rect9, _path29, _rect0, _tspan22, _path30, _circle6, _path31, _rect1, _tspan23, _rect10, _tspan24, _tspan25, _rect11, _tspan26, _tspan27, _tspan28, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignal1Asp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1305,
    height: 234,
    viewBox: "0 0 1305 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1305,
    height: 234,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "C-HG/RG",
    clipPath: "url(#clip0_0_1)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1305,
    height: 234,
    fill: "white"
  })), /*#__PURE__*/React.createElement("text", {
    id: ".........................",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 1180,
    y: 63.8636
  }, "........................."))), /*#__PURE__*/React.createElement("text", {
    id: "........................._2",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 929,
    y: 63.8636
  }, "........................."))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 192",
    width: 1305,
    height: 234,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14",
    x: 74,
    y: 61,
    width: 309,
    height: 108,
    stroke: "black",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 193",
    x: 423,
    y: 61,
    width: 187,
    height: 108,
    stroke: "black",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 194",
    x: 670,
    y: 61,
    width: 75,
    height: 108,
    stroke: "black",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 195",
    x: 813,
    y: 61,
    width: 93,
    height: 108,
    stroke: "black",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RG_Wiring"
  }, /*#__PURE__*/React.createElement("text", {
    id: "RGNX",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 387.168,
    y: 127.208
  }, "RGNX"))), /*#__PURE__*/React.createElement("text", {
    id: "RGBX",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 387.168,
    y: 91.1619
  }, "RGBX"))), /*#__PURE__*/React.createElement("g", {
    id: "CTR A5/7"
  }, /*#__PURE__*/React.createElement("text", {
    id: "CTR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 628.326,
    y: 86.6562
  }, "CTR"))), /*#__PURE__*/React.createElement("text", {
    id: "CTR_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 628.326,
    y: 137.346
  }, "CTR"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2",
    cx: 648.527,
    cy: 91.7011,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3",
    d: "M652.065 91.7011C652.065 93.4033 650.509 94.8304 648.527 94.8304C646.546 94.8304 644.989 93.4033 644.989 91.7011C644.989 89.9989 646.546 88.5718 648.527 88.5718C650.509 88.5718 652.065 89.9989 652.065 91.7011Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group 21"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_2",
    cx: 627.064,
    cy: 91.7011,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_2",
    d: "M630.602 91.7011C630.602 93.4033 629.046 94.8304 627.064 94.8304C625.083 94.8304 623.526 93.4033 623.526 91.7011C623.526 89.9989 625.083 88.5718 627.064 88.5718C629.046 88.5718 630.602 89.9989 630.602 91.7011Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line 49",
    d: "M630.22 91.701H645.371",
    stroke: "black",
    strokeWidth: 3
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group 23"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_3",
    cx: 648.527,
    cy: 141.828,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_3",
    d: "M652.065 141.828C652.065 143.53 650.509 144.957 648.527 144.957C646.546 144.957 644.989 143.53 644.989 141.828C644.989 140.125 646.546 138.698 648.527 138.698C650.509 138.698 652.065 140.125 652.065 141.828Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group 24"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_4",
    cx: 627.064,
    cy: 141.828,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_4",
    d: "M630.602 141.828C630.602 143.53 629.046 144.957 627.064 144.957C625.083 144.957 623.526 143.53 623.526 141.828C623.526 140.125 625.083 138.698 627.064 138.698C629.046 138.698 630.602 140.125 630.602 141.828Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Line 53",
    d: "M630.22 141.828H645.371",
    stroke: "black",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 77",
    d: "M649.791 95.6436H651.685L653.579 93.6723V91.7011V89.7298L651.685 87.7585H649.791",
    stroke: "black",
    strokeWidth: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 78",
    d: "M649.791 145.77H651.685L653.579 143.799V141.828V139.856L651.685 137.885H649.791",
    stroke: "black",
    strokeWidth: 0.25
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "LB2TRACKSIDE_RG_UP_WIRE",
    d: "M850.545 102.402V91.701H653.578",
    stroke: "black",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "LB2TRACKSIDE_RG_UP_WIRE_2",
    d: "M623.5 92H480",
    stroke: "black",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "LB2TRACKSIDE_RG_DN_WIRE",
    d: "M850.545 129.437V141.828H653.578",
    stroke: "black",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 80",
    cx: 682.618,
    cy: 91.7012,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 81",
    cx: 682.618,
    cy: 141.828,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_5",
    cx: 734.386,
    cy: 91.7012,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_5",
    d: "M737.173 91.7011C737.173 92.9109 736.036 94.0804 734.385 94.0804C732.735 94.0804 731.598 92.9109 731.598 91.7011C731.598 90.4913 732.735 89.3218 734.385 89.3218C736.036 89.3218 737.173 90.4913 737.173 91.7011Z",
    stroke: "black",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 83",
    d: "M685.406 91.7011C685.406 92.9109 684.268 94.0804 682.618 94.0804C680.968 94.0804 679.83 92.9109 679.83 91.7011C679.83 90.4913 680.968 89.3218 682.618 89.3218C684.268 89.3218 685.406 90.4913 685.406 91.7011Z",
    stroke: "black",
    strokeWidth: 2
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_6",
    cx: 734.385,
    cy: 141.828,
    rx: 2.52522,
    ry: 2.25287,
    transform: "rotate(-180 734.385 141.828)",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_6",
    d: "M731.597 141.827C731.597 140.618 732.735 139.448 734.385 139.448C736.035 139.448 737.173 140.618 737.173 141.827C737.173 143.037 736.035 144.207 734.385 144.207C732.735 144.207 731.597 143.037 731.597 141.827Z",
    stroke: "black",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 85",
    d: "M679.831 141.827C679.831 140.618 680.968 139.448 682.618 139.448C684.268 139.448 685.406 140.618 685.406 141.827C685.406 143.037 684.268 144.207 682.618 144.207C680.968 144.207 679.831 143.037 679.831 141.827Z",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "R2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 326.562,
    y: 125.208
  }, "R2"))), /*#__PURE__*/React.createElement("text", {
    id: "R1",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 372.016,
    y: 125.208
  }, "R1"))), /*#__PURE__*/React.createElement("g", {
    id: "CALLING_SIGNAL"
  }, /*#__PURE__*/React.createElement("text", {
    id: "C1HECR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 335.501,
    y: 139.725
  }, "CHECR"))), /*#__PURE__*/React.createElement("text", {
    id: "C-HG_Name",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10,
    letterSpacing: "0em"
  }, _tspan0 || (_tspan0 = /*#__PURE__*/React.createElement("tspan", {
    x: 876,
    y: 124.636
  }, "C-HG")))), /*#__PURE__*/React.createElement("g", {
    id: "RG_Signal"
  }, /*#__PURE__*/React.createElement("text", {
    id: "RG_Name",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10,
    letterSpacing: "0em"
  }, _tspan1 || (_tspan1 = /*#__PURE__*/React.createElement("tspan", {
    x: 887,
    y: 120.636
  }, "RG"))), /*#__PURE__*/React.createElement("text", {
    id: "RECR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 340,
    y: 140.909
  }, "RECR")))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 90",
    cx: 141.17,
    cy: 130.747,
    r: 4,
    fill: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "BX110",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 101,
    y: 94.9091
  }, "BX110"))), /*#__PURE__*/React.createElement("text", {
    id: "CHR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 186,
    y: 80.9091
  }, "CHR"))), /*#__PURE__*/React.createElement("text", {
    id: "CHR_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 184,
    y: 146.909
  }, "CHR"))), /*#__PURE__*/React.createElement("text", {
    id: "NX110",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 101,
    y: 136.587
  }, "NX110"))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 88",
    cx: 142.434,
    cy: 93.1377,
    r: 4,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 89",
    cx: 162.635,
    cy: 93.1377,
    r: 4,
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 64",
    d: "M330.351 129.437V145.207H372.017V129.437",
    stroke: "black",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 66",
    d: "M191.463 97.8965L187.675 93.3907L183.887 97.8965",
    stroke: "black",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 67",
    cx: 212.639,
    cy: 92.8217,
    r: 3.5,
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 67",
    d: "M212.927 135.632L208.508 131.126L205.351 135.632",
    stroke: "black",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 71",
    cx: 183.6,
    cy: 130.121,
    r: 3.5,
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "RR_UP_WIRE_RG",
    d: "M454.086 91.701L139.696 93.3574",
    stroke: "black",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "RR_DN_WIRE_RG",
    d: "M454.086 128.873L139.696 130.57",
    stroke: "black",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "SPD2CTR_RG_DN_WIRE",
    d: "M500.803 141.828L623.276 141.828",
    stroke: "black",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "SPD2CTR_RG_DN_WIRE_2",
    d: "M480.602 128.874H500.803V142.391",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "B20SPD"
  }, /*#__PURE__*/React.createElement("text", {
    id: 6,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 451.56,
    y: 102.426
  }, "6"))), /*#__PURE__*/React.createElement("text", {
    id: 5,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 474.287,
    y: 102.426
  }, "5"))), /*#__PURE__*/React.createElement("text", {
    id: 1,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 474.287,
    y: 139.599
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    id: 2,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 452.822,
    y: 139.599
  }, "2"))), /*#__PURE__*/React.createElement("text", {
    id: 4,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 452.822,
    y: 155.369
  }, "4"))), /*#__PURE__*/React.createElement("text", {
    id: 3,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 474.287,
    y: 155.369
  }, "3"))), /*#__PURE__*/React.createElement("text", {
    id: "SPD",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    x: 452.822,
    y: 79.8976
  }, "SPD"))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 66",
    cx: 455.347,
    cy: 91.7011,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 75",
    d: "M479.6 91.7011C479.6 92.9109 478.462 94.0804 476.812 94.0804C475.162 94.0804 474.024 92.9109 474.024 91.7011C474.024 90.4913 475.162 89.3218 476.812 89.3218C478.462 89.3218 479.6 90.4913 479.6 91.7011Z",
    stroke: "black",
    strokeWidth: 2
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 76",
    cx: 455.347,
    cy: 128.873,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 77",
    d: "M479.6 128.873C479.6 130.083 478.462 131.253 476.812 131.253C475.162 131.253 474.024 130.083 474.024 128.873C474.024 127.664 475.162 126.494 476.812 126.494C478.462 126.494 479.6 127.664 479.6 128.873Z",
    stroke: "black",
    strokeWidth: 2
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 78",
    cx: 455.347,
    cy: 144.644,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 79",
    d: "M479.6 144.644C479.6 145.853 478.462 147.023 476.812 147.023C475.162 147.023 474.024 145.853 474.024 144.644C474.024 143.434 475.162 142.264 476.812 142.264C478.462 142.264 479.6 143.434 479.6 144.644Z",
    stroke: "black",
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Line 50",
    d: "M457.873 91.701H473.656",
    stroke: "black",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Line 51",
    d: "M457.873 128.874H473.656",
    stroke: "black",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Line 52",
    d: "M457.873 144.644H473.656",
    stroke: "black",
    strokeWidth: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 9",
    x: 444,
    y: 83,
    width: 44,
    height: 74,
    stroke: "black",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Line 56",
    d: "M466.711 160.414V145.176",
    stroke: "black",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line 57",
    x1: 460.398,
    y1: 159.977,
    x2: 473.025,
    y2: 159.977,
    stroke: "black",
    strokeWidth: 2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Line 58",
    d: "M461.661 161.399H472.155",
    stroke: "black",
    strokeWidth: 2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Line 59",
    d: "M462.924 161.878H470.499",
    stroke: "black",
    strokeWidth: 2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Line 60",
    d: "M464.187 162.385H469.237",
    stroke: "black",
    strokeWidth: 2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Line 61",
    d: "M465.449 163.005H467.974",
    stroke: "black",
    strokeWidth: 2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Line 64",
    d: "M464.187 162.385H469.237",
    stroke: "black",
    strokeWidth: 2
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "CHG_LED Signal HG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1",
    d: "M864.697 116.483C864.697 123.603 858.189 129.563 849.914 129.563C841.64 129.563 835.132 123.603 835.132 116.483C835.132 109.363 841.64 103.402 849.914 103.402C858.189 103.402 864.697 109.363 864.697 116.483Z",
    stroke: "black",
    strokeWidth: 2
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4",
    x: 825.031,
    y: 84.2528,
    width: 48.5044,
    height: 66.7126,
    stroke: "black",
    strokeWidth: 2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Line 153",
    d: "M142 92.8709C151.13 69.6246 152 114.633 162 92.8709",
    stroke: "black"
  }))), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 196",
    x: 921,
    y: 40,
    width: 369,
    height: 161,
    fill: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "VRG",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    x: 938,
    y: 132.864
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 172",
    d: "M1066.5 127.5C1066.5 108.722 1081.72 93.5 1100.5 93.5C1119.28 93.5 1134.5 108.722 1134.5 127.5V176.5H1066.5V127.5Z",
    stroke: "white",
    strokeWidth: 3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 155",
    cx: 1101,
    cy: 140,
    r: 25,
    fill: "black",
    stroke: "white",
    strokeWidth: 2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "aSPECT_CURRENT",
    d: "M1120 139.5C1120 150.293 1111.47 159 1101 159C1090.53 159 1082 150.293 1082 139.5C1082 128.707 1090.53 120 1101 120C1111.47 120 1120 128.707 1120 139.5Z",
    fill: "#979393",
    stroke: "white",
    strokeWidth: 2
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 178",
    x: 928.5,
    y: 91.5,
    width: 124,
    height: 95,
    rx: 4.5,
    stroke: "white"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PROVING_RELAY_TIME",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    x: 931,
    y: 105.909
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 190",
    x: 1007,
    y: 98,
    width: 44,
    height: 10,
    rx: 5,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("text", {
    id: "RELAY",
    transform: "translate(1017 98)",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.90909
  }, "RELAY"))), /*#__PURE__*/React.createElement("text", {
    id: "DPR",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    x: 1156,
    y: 131.864
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 197",
    x: 1150.5,
    y: 91.5,
    width: 124,
    height: 95,
    rx: 4.5,
    stroke: "white"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Calling_Signl_Time",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    x: 1153,
    y: 105.909
  }))), /*#__PURE__*/React.createElement("text", {
    id: "SG_NAME",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    letterSpacing: "0em"
  }, _tspan27 || (_tspan27 = /*#__PURE__*/React.createElement("tspan", {
    x: 1188,
    y: 69.9091
  }, ".........."))), /*#__PURE__*/React.createElement("text", {
    id: "LOC_NAME",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    letterSpacing: "0em"
  }, _tspan28 || (_tspan28 = /*#__PURE__*/React.createElement("tspan", {
    x: 939,
    y: 69.9091
  }, "..........")))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1305,
    height: 234,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignal1Asp);
export default __webpack_public_path__ + "static/media/signal_1asp.40d027dba6d9666a7405216a495b92fc.svg";
export { ForwardRef as ReactComponent };